module.exports = __webpack_public_path__ + "img/mustard.0a4fb466.svg";